import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {SettingsSmsComponent} from './settings-sms.component';
import {SettingsSmsDetailedViewComponent} from './settings-sms-detailed-view/settings-sms-detailed-view.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {SettingsSmsListComponent} from './settings-sms-list/settings-sms-list.component';
import {SettingsSmsService} from '../../services/settings-sms.service';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        UtilsModule
    ],
    declarations: [
        SettingsSmsComponent,
        SettingsSmsDetailedViewComponent,
        SettingsSmsListComponent,
    ],
    providers: [
        SettingsSmsService
    ]
})
export class SettingsSmsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-sms/settings-sms.module.ts